export default __webpack_public_path__ + "static/media/placeholder_dummy2016-personal01-mobile-de.550095e5.png";